import { format } from 'date-fns';
import { generateURL } from 'utils/helpers';
import { FORMAT_QT_DATE } from 'utils/helpers/datetime';

const availability = {
  unavailableDates: ({ resourceIDs, fromDate, toDate }) => {
    const url = generateURL('/availability/unavailable_dates', {
      resource_ids: resourceIDs,
      date_from: fromDate,
      date_to: toDate,
    });

    return fetch(url).then((response) => response.json());
  },

  dateRangeBookability: ({
    resourceIds,
    passengerTypeNumbers,
    fromDate,
    toDate,
  }) => {
    const url = generateURL('/availability/date_range_bookability', {
      resource_ids: resourceIds,
      passenger_type_numbers: passengerTypeNumbers,
      date_from: fromDate,
      date_to: toDate,
    });

    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },

  dateRangeBulkAvailability: ({
    resourceIDs,
    units,
    fromDate,
    toDate,
    signal,
  }) => {
    const url = generateURL('/availability/bulk', {
      'resource_ids[]': resourceIDs,
      units,
      date_from: format(fromDate, FORMAT_QT_DATE),
      date_to: format(toDate, FORMAT_QT_DATE),
    });
    return fetch(url, {
      method: 'GET',
      signal,
    }).then((response) => response.json());
  },
};

export default availability;
